import React from 'react';

import { Spin } from 'antd';
import clsx from 'clsx';
import { t } from 'i18next';

import Logo from '@/assets/v2/logo.svg?react';
import { Button } from '@/components/common/Button';
import { buildAppUrl, shouldShowOpenAppButton } from '@/shared/constance/appConfig';
import GlassGridBackground from '@/v2/components/GlassGridBackground';

import { getUserInfoByUUID } from './api';

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const Loading = () => {
  return (
    <div className="flex size-full items-center justify-center bg-transparent">
      <Spin style={{ display: 'flex' }} />
    </div>
  );
};

interface State {
  auth_result: boolean;
  avatar: string | undefined;
  username: string | undefined;
  displayName: string | undefined;
  email: string | undefined;
  uuid: string | undefined;
  loading: boolean;
}
class KwaipilotAuthResult extends React.Component<Record<string, never>, State> {
  constructor(props: Record<string, never>) {
    super(props);
    this.state = {
      auth_result: false,
      avatar: undefined,
      username: undefined,
      displayName: undefined,
      email: undefined,
      uuid: undefined,
      loading: true,
    };
  }

  async componentDidMount() {
    // 获取查询参数字符串
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    // 获取特定参数的值
    const uuid: string | undefined = params.get('uuid')?.toUpperCase();
    try {
      await sleep(1000);
      for (let i = 0; i < 5; i++) {
        let userinfo:
          | { displayName?: string; username?: string; avatar?: string; mail?: string }
          | undefined = undefined;
        try {
          userinfo = await getUserInfoByUUID(uuid?.toLowerCase() || '');
        } catch (error) {
          console.error('获取用户信息失败, 错误原因：', error);
        }
        if (!userinfo) {
          // eslint-disable-next-line no-console
          console.log('认证尝试第', i + 1, '次');
          await sleep(1000 * i);
          continue;
        }
        const displayName = userinfo?.displayName;
        const username = userinfo?.username;
        const avatar = userinfo?.avatar;
        const auth_result = true;
        this.setState({
          auth_result,
          avatar,
          username,
          displayName,
          uuid,
          loading: false,
          email: userinfo?.mail,
        });
        return;
      }
      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { displayName, email, loading, auth_result, uuid } = this.state;
    // 从URL获取uuid参数，用于判断是否显示按钮
    const urlParams = new URLSearchParams(window.location.search);
    const urlSource = urlParams.get('source');
    const isServerSource = urlSource === 'server';
    const referrer = urlParams.get('referrer');
    const showOpenCodeFlickerButton = shouldShowOpenAppButton(referrer) && auth_result;

    return (
      <div className="relative h-screen w-screen text-sm">
        {!!loading && <Loading />}
        {!loading && (
          <div className="relative flex size-full flex-col items-center justify-center overflow-hidden">
            <GlassGridBackground />
            <div className="z-10 mx-auto size-full max-w-[1728px] px-[88px] pt-[34px]">
              <div
                className={clsx(
                  'z-10 flex cursor-pointer items-center gap-5',
                  'xs:h-[clamp(24px,4vw,32px)] h-6 lg:h-8',
                )}
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                <Logo />
              </div>
              {/* 内容容器 */}
              <div className="relative z-10 flex size-full flex-col items-center justify-center text-[#111314]">
                <div id="11" className="text-center leading-normal">
                  {auth_result ? (
                    <div className="text-[48px] font-semibold text-[#111314]">
                      {t('auth.authResult.ssoLoginSuccess')}&nbsp;
                      <span className="text-[#5FE9D9]">{t('auth.authResult.success')}</span>
                    </div>
                  ) : (
                    <div className="text-[48px] font-semibold">
                      {t('auth.authResult.ssoAuthFailed')}
                    </div>
                  )}

                  {auth_result ? (
                    <div className="mt-3 text-center text-[16px] text-[#111314]">
                      <span className="text-[#BABCBC]">{t('auth.authResult.loginAccount')}</span>{' '}
                      {displayName} {email}
                    </div>
                  ) : (
                    <div className="mt-3 text-center text-[16px] text-[#111314]">
                      {t('auth.authResult.loginFailedContact')}
                    </div>
                  )}

                  {/* 根据是否有uuid条件渲染按钮 */}
                  {showOpenCodeFlickerButton && (
                    <div className="mt-8 flex justify-center gap-4">
                      <div>
                        <Button
                          onClick={() => {
                            window.location.href = isServerSource
                              ? buildAppUrl(referrer, 'login', { source: 'web', uuid: uuid || '' })
                              : buildAppUrl(referrer, 'open');
                          }}
                          className=" whitespace-nowrap"
                        >
                          {t(
                            referrer === 'duet'
                              ? 'auth.authResult.openDuet'
                              : 'auth.authResult.openCodeflicker',
                          )}
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default KwaipilotAuthResult;
